import {getRoute} from "@common/vue/store/routes";

export default {
    state: {
        errorText: '',
        saveErrors: '',
        isLoading: true,
        addedTask: {
            url: '',
            urlId: null,
            service: null,
        },
        newTasks: [],
        newStages: [],
        results: [],
    },

    mutations: {
        setTaskData(state, { urlId, url, service }) {
            state.addedTask.urlId = urlId || null;
            state.addedTask.url = url || '';
            state.addedTask.service = service || null;
        },
        setLoading(state, val) {
            state.isLoading = val;
        },
        setError(state, val) {
            state.errorText = val;
        },
        setSaveErrors(state, val) {
            state.saveErrors = val;
        },
    },

    actions: {
        /**
         * Получение данных о наличии урла в одном из сервисов
         */
        async checkExistingURLs({state, commit}, url) {
            commit('setError', '');
            commit('setSaveErrors', '');
            commit('setLoading', true);
            commit('setTaskData', {});

            if (!url) return;

            const api = getRoute('plan-tasks-project', 'get-runs-by-url/');
            return axios.post(api, { url })
                .then((res) => {
                    const data = {
                        url,
                        urlId: res.data?.urlId || null,
                        service: res.data?.service || null,
                    };

                    commit('setTaskData', data);
                    commit('setLoading', false);

                    return res;
                })
                .catch((error) => {
                    if (error.response.status === 403) {
                        state.errorText = 'Ошибка доступа';
                    } else {
                        state.errorText = 'При запросе произошла ошибка. Попробуйте позднее'
                    }

                    commit('setLoading', false);

                    console.error('checkExistingURLs', error.response || error);
                    return error;
                });
        },
        /**
         * plan-tasks/project/1358/api/create-plan-task
         * Добавление задачи на основе url:
         * POST: plan-tasks/project/[:projectId]/api/create-plan-task
         *
         * @param @inheritdoc
         * @param {{task: PlanTaskModel, object: string}} Payload
         */
        async createUrlTask({state, commit}, {task, object}) {
            commit('setSaveErrors', '');
            const data = {
                ...task.toServerFormat({object}),
                url: state.addedTask.url,
            };

            return axios.post(getRoute('plan-tasks-project', 'create-plan-task/'), data)
                .catch((e) => {
                    console.error('createUrlTask', e.response?.data || e.response || e);
                    commit('setSaveErrors', e.response?.data?.error || 'При создании произошла ошибка');
            });
        },
    },
};
